import { DeleteIcon, DoubleArrowIcon } from "../../../../../assets/icons";

export const ContractFailedCard = ({ title, description, onRetry }) => (
  <div className="w-full max-w-sm lg:max-w-md rounded-xl border border-danger/20 bg-danger/10 p-4 text-left shadow-sm">
    <div className="flex items-start gap-3">
      <span className="mt-0.5 inline-flex h-8 w-8 items-center justify-center rounded-full bg-danger/20 text-danger">
        <DeleteIcon width={16} height={16} />
      </span>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-danger truncate">
          {title || "Contract failed"}
        </p>
        <p className="mt-1 text-xs text-danger/80 text-pretty line-clamp-3">
          {description || "We couldn't generate this contract. Try again."}
        </p>
        {onRetry && (
          <button
            type="button"
            onClick={onRetry}
            className="mt-3 inline-flex items-center gap-1.5 text-xs font-semibold text-danger hover:text-danger transition-colors cursor-pointer"
          >
            Retry Generation
            <DoubleArrowIcon width={12} height={12} className="text-danger" />
          </button>
        )}
      </div>
    </div>
  </div>
);
